import React, { Component } from "react";
import * as s from "./SingleSelectDropdown.module.scss";
import { Icons } from "src/libs/assets";
import { P } from "src/views/shared/components";
import { ChoiceButtonOption } from "../ThreeChoiceButton";

interface Props extends React.HtmlHTMLAttributes<HTMLDivElement> {
  toggleOption: (any) => void;
  options: { value: string; selected: boolean }[];
  label?: string;
}

interface State {
  dropdownOpen: boolean;
}

export class SingleSelectDropdown extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = { dropdownOpen: false };
  }

  toggleDropdown = () => {
    this.setState({ dropdownOpen: !this.state.dropdownOpen });
  };

  renderDropdownOption = (option, key) => {
    const { toggleOption } = this.props;

    return (
      <div
        className={s.dropdownOption}
        onClick={() => {
          toggleOption(option);
          this.toggleDropdown();
        }}
        key={key}
      >
        <P small className={s.dropdownOptionLabel}>
          {option.value}
        </P>
      </div>
    );
  };

  renderSelectedItem = item => {
    let value = item?.value;
    let dropdownItemClasses = [s.dropdownOption, s.selected];

    return <div className={dropdownItemClasses.join(" ")}>{value}</div>;
  };

  render() {
    const { className, options, label } = this.props;
    const { dropdownOpen } = this.state;
    let singleSelectDropdownContainerClasses = [s.singleSelectDropdownContainer];
    let selectedItem = options?.find(item => item.selected);

    const labelClasses = [s.label];
    const dropdownClasses = [s.dropdown];

    if (className) singleSelectDropdownContainerClasses.push(className);
    if (dropdownOpen) dropdownClasses.push(s.open);
    if (selectedItem && label) labelClasses.push(s.selected);

    return (
      <div className={singleSelectDropdownContainerClasses.join(" ")}>
        <div className={s.selectedContainer} onClick={this.toggleDropdown}>
          {this.renderSelectedItem(selectedItem)}
          {label && <label className={labelClasses.join(" ")}>{label}</label>}
          <img
            src={Icons.dropdown_small}
            alt="dropdown-chevron"
            className={s.dropdownIcon}
          />
        </div>
        <div className={dropdownClasses.join(" ")}>
          {options &&
            options.filter(item => !item.selected).map(this.renderDropdownOption)}
        </div>
      </div>
    );
  }
}

interface SingleSelectDropdownNewProps extends React.HtmlHTMLAttributes<HTMLDivElement> {
  toggleOption: (any) => void;
  options: ChoiceButtonOption[];
  label?: string;
  selected: string;
}

//TODO: This is a temporary duplicate of above component since there is no time to refactor.
// However I am a bit perplexed by the state handling in these components. would like to dumb them
// down or smart them up :D. we are passing down observables which we manipulate and I can't really
// wrap my head around if we want those things kept in global state through mobx store. state seems
// much more local in the different forms :thinking_face: oh well!
export class SingleSelectDropdownNew extends Component<
  SingleSelectDropdownNewProps,
  State
> {
  constructor(props) {
    super(props);
    this.state = { dropdownOpen: false };
  }

  toggleDropdown = () => {
    this.setState({ dropdownOpen: !this.state.dropdownOpen });
  };

  renderDropdownOption = (option, key) => {
    const { toggleOption } = this.props;

    return (
      <div
        className={s.dropdownOption}
        onClick={() => {
          toggleOption(option);
          this.toggleDropdown();
        }}
        key={key}
      >
        <P small className={s.dropdownOptionLabel}>
          {option.label}
        </P>
      </div>
    );
  };

  renderSelectedItem = item => {
    let label = item?.label;
    let dropdownItemClasses = [s.dropdownOption, s.selected];

    return <div className={dropdownItemClasses.join(" ")}>{label}</div>;
  };

  render() {
    const { className, options = [], label, selected } = this.props;
    const { dropdownOpen } = this.state;
    let singleSelectDropdownContainerClasses = [s.singleSelectDropdownContainer];
    let selectedItem = options?.find(item => item.value == selected);

    const labelClasses = [s.label];
    const dropdownClasses = [s.dropdown];

    if (className) singleSelectDropdownContainerClasses.push(className);
    if (dropdownOpen) dropdownClasses.push(s.open);
    if (selectedItem && label) labelClasses.push(s.selected);

    return (
      <div className={singleSelectDropdownContainerClasses.join(" ")}>
        <div className={s.selectedContainer} onClick={this.toggleDropdown}>
          {this.renderSelectedItem(selectedItem)}
          {label && <label className={labelClasses.join(" ")}>{label}</label>}
          <img
            src={Icons.dropdown_small}
            alt="dropdown-chevron"
            className={s.dropdownIcon}
          />
        </div>
        <div className={dropdownClasses.join(" ")}>
          {options.filter(item => item.value != selected).map(this.renderDropdownOption)}
        </div>
      </div>
    );
  }
}
